import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

if (!process.env.REACT_APP_FIREBASE_API_KEY) {
  throw new Error('Missing Firebase configuration environment variables');
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Always specify region for consistency
export const functions = getFunctions(app, 'us-central1');

// Only connect to Functions emulator when explicitly enabled
const useEmulator = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Get emulator port from environment variable or use default 5001
const functionsEmulatorPort = process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT 
  ? parseInt(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT, 10) 
  : 5001;

if (isLocalhost && useEmulator) {
  connectFunctionsEmulator(functions, 'localhost', functionsEmulatorPort);
  console.log(`Running on ${window.location.hostname}:${window.location.port} - functions connecting to emulator`);
  console.log(`Firebase Functions Emulator URL: localhost:${functionsEmulatorPort}`);
} else if (isLocalhost) {
  console.log(`Running on localhost but using production Firebase Functions (emulators disabled)`);
} 